import { classNames } from 'primereact/utils';
import { MouseEventHandler, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useGetAuftragMutation, useGetHistoriePublicMutation, useSpeicherAuftragMutation } from '../../api/AuftragAPI';
import UploadToServer from '../../component/UploadToServer';
import { IAuftrag, IAuftragHistorie, IAuftragRequest } from '../../types/Types';
import { formatToEuroDate } from '../../util/DateUtils';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from './eigeneauftraege.module.scss';
import MapComponent, { ILocation } from '../../component/MapComponent/MapComponent';

/**
 * @author noone
 */
export default function EigeneAuftraegeDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { uid } = useParams<{ uid: string }>();

  const [getAuftragHistoriePublic] = useGetHistoriePublicMutation();
  const [getAuftrag] = useGetAuftragMutation();
  const [speicherAuftragAPI] = useSpeicherAuftragMutation();


  const [auftrag, setAuftrag] = useState<IAuftrag>();
  const [historie, setHistorie] = useState<IAuftragHistorie[]>([]);
  const [isLoaded, setLoaded] = useState<boolean>(false);

  const lade = () => {

    getAuftrag(uid!!).unwrap()
      .then((data) => setAuftrag(data))
      .then(() => setLoaded(true))
      ;

    getAuftragHistoriePublic(uid!!).unwrap().then((data) => setHistorie(data));
  }

  const locationset = (location: ILocation) => {
    if (auftrag !== undefined) {
      setAuftrag((prevData) => {
        if (!prevData) return undefined; // Handle undefined case
        return {
          ...prevData,
          strasse_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'route')?.long_name || '',
          hausnummer_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'street_number')?.long_name || '',
          postleitzahl_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'postal_code')?.long_name || '',
          stadt_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'locality')?.long_name || '',
          land_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'country')?.long_name || '',
          lat: location.lat,
          lng: location.lng,
        };
      });
    }
  };

  const speichern = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    speicherAuftragAPI({
      uid: auftrag?.uid!!,
      art: auftrag?.art!!,
      spaetmesstermin: auftrag?.spaetmesstermin!!,
      vorname_endkunde: auftrag?.vorname_endkunde!!,
      name_endkunde: auftrag?.name_endkunde!!,
      strasse_lieferadresse: auftrag?.strasse_lieferadresse!!,
      hausnummer_lieferadresse: auftrag?.hausnummer_lieferadresse!!,
      postleitzahl_lieferadresse: auftrag?.postleitzahl_lieferadresse!!,
      stadt_lieferadresse: auftrag?.stadt_lieferadresse!!,
      land_lieferadresse: auftrag?.land_lieferadresse!!,
      besonderheiten: auftrag?.besonderheiten!!,
      messzeitpunkt: auftrag?.messzeitpunkt!!,
      telefon_lieferadresse: auftrag?.telefon_lieferadresse!!,
      email_lieferadresse: auftrag?.email!!,
      mobil1_lieferadresse: auftrag?.mobil1_lieferadresse!!,
      mobil2_lieferadresse: auftrag?.mobil2_lieferadresse!!,
      ansprechpartner: auftrag?.ansprechpartner!!,
      kontakt_ansprechpartner: auftrag?.kontakt_ansprechpartner!!,
      auftragsnr_ag: auftrag?.auftragsnr_ag!!,
      lat: auftrag?.lat!!,
      lng: auftrag?.lng!!,
    }).then( () => navigate({
      pathname: "/",
      search: ""
    }) );

  }

  useEffect(() => {
    lade();
  }, []);

  return (
    <div className={classNames(styles.centerContainer)} key={location.pathname} >

      <LandingpageHeader />

      <div style={{ width: "80%" }}>

        <button
          onClick={() => {
            navigate({
              pathname: "/",
              search: ""
            });
          }}

          style={{ marginBottom: "20px" }}
          className=' btn btn-outline-primary'
        >
          <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
        </button>
      </div>

      {isLoaded &&
        <>
          <div style={{ display: 'grid', gridTemplateColumns: '70%  30%', columnGap: "30px", width: "80%" }}>
            <div>

              <h3>{t('deTranslation.auftragDetails.titel')}</h3>

              <div className="form-group">
                {t('deTranslation.auftragDetails.art')}:
                <input readOnly={true} className='form-control' name="art" value={auftrag?.art} /> {/*onChange={handleChange}*/}
              </div>

              <div className="card" style={{ padding: "30px", marginBottom: "30px" }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 3fr" }}>
                  <div>

                    Lieferadresse:
                    <p></p>
                    <br />{auftrag?.vorname_endkunde} {auftrag?.name_endkunde}
                    <br />{auftrag?.strasse_lieferadresse} {auftrag?.hausnummer_lieferadresse}
                    <br />{auftrag?.postleitzahl_lieferadresse} {auftrag?.stadt_lieferadresse}
                    <br />{auftrag?.land_lieferadresse}
                    <p></p>
                    <br />Telefon: {auftrag?.telefon_lieferadresse}
                    <br />Mobil1: {auftrag?.mobil1_lieferadresse}
                    <br />Mobil2: {auftrag?.mobil2_lieferadresse}
                    <br />E-Mail: {auftrag?.email}
                  </div>
                  <div>
                    <div style={{ height: '500px', width: '100%' }}>
                      <MapComponent onLocationSet={locationset} startLng={auftrag?.lng} startLat={auftrag?.lat} />
                    </div>
                     { (auftrag?.status==="NEU" || auftrag?.status==="IN_TERMINIERUNG" || auftrag?.status==="WIEDERVORLAGE" )&&
                    <button className='btn btn-primary' value="Speichern" onClick={speichern}><i className="bi bi-plus"></i> Speichern</button>
                     }
                  </div>
                </div>
              </div>

              {/*<div className="form-group">
                {t('deTranslation.auftragDetails.telefon_lieferadresse')}:
                <input readOnly={true} className='form-control' name="telefon_lieferadresse" value={auftrag?.telefon_lieferadresse} />
              </div>*/}

              Aktionen (neuste zuerst):
              <ul>
                {historie?.map((e, index) =>
                  <li key={index}>{(e.datum !== null) ? formatToEuroDate(e.datum) : "--"} {e.text!!}</li>
                )}
              </ul>

            </div>

            <UploadToServer uid={uid ?? ''} />

          </div>

        </>}

      <Footer />
    </div>
  );

}


